import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "geo-item-search comment" }
const _hoisted_2 = { class: "damage-rank" }
const _hoisted_3 = { class: "font-sm" }
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = { class: "share-scope" }
const _hoisted_7 = { class: "font-sm" }
const _hoisted_8 = { class: "form-group mb0 mr16 ml15" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "only-current-user" }
const _hoisted_11 = { class: "font-sm" }
const _hoisted_12 = { class: "custom-control custom-checkbox ml15" }

import {
  computed,
  onMounted,
  reactive,
  ref,
} from 'vue';
import GeoItemSearchCommon from 'src/components/Top/geoItemSearchComponents/GeoItemSearchCommon.vue';
import type { CommonSearchParams, SearchType, SearchTypeMap } from 'src/models/geoItemSearch';
import { useReactiveMasters } from 'src/composables/useMasters';
import type { CommentIndexParams } from 'src/models/apis/comment/commentRequest';
import { COMMENT_DAMAGE_RANK_SEARCH_OPTIONS, type CommentDamageRankSearch } from 'src/consts/comment_damage_rank';

interface SearchParams {
  shareScope: number | null;
  onlyCurrentUser: boolean;
  damageRanks: CommentDamageRankSearch[];
}

interface GeoItemSearchCommentState {
  showShareScope: boolean;
  showOnlyCurrentUser: boolean;
  showDamageRank: boolean;
  search: SearchParams;
}

const checkboxKeyPrefix = 'comment';


export default /*@__PURE__*/_defineComponent({
  __name: 'GeoItemSearchComment',
  emits: ["change"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const initSearchState = (): SearchParams => {
  return {
    shareScope: null,
    onlyCurrentUser: false,
    damageRanks: [],
  };
};
const state = reactive<GeoItemSearchCommentState>({
  showShareScope: false,
  showOnlyCurrentUser: false,
  showDamageRank: false,
  search: initSearchState(),
});
const { masters, resolveMastersPromise } = useReactiveMasters();

const searchTypes = computed<SearchType[]>(() => {
  return masters.comment.commentTypes.map(e => {
    return {'key': e.commentType, 'val': e.commentTypeDisp};
  });
});
const searchTypeMap = computed<SearchTypeMap>(() => {
  const map: SearchTypeMap = {};
  masters.comment.commentTypes.forEach(e => {
    map[e.commentType] = { val: e.commentTypeDisp, dispOrder: e.dispOrder };
  });
  return map;
});

const setInitialSearchParams = () => {
  const params = {
    shareScope: masters.lov.shareScopes[0].key,
    onlyCurrentUser: false,
    damageRanks: [],
  };
  state.search = params;
};

const selectedShareScopeDisp = computed<string>(() => {
  if (!state.search.shareScope) return '';

  const ret = masters.lov.shareScopeMap[state.search.shareScope].valAlt;
  return `（${ret}）`;
});
const onlyCurrentUserDisp = computed<string>(() => {
  const ret = state.search.onlyCurrentUser ? '自分のみ' : '全て';
  return `（${ret}）`;
});
const damageRankLabelMap = new Map(COMMENT_DAMAGE_RANK_SEARCH_OPTIONS.map(option => [option.value, option.label]));
const selectedDamageRankDisp = computed<string>(() => {
  if (state.search.damageRanks.length === 0) return '';

  const labels = state.search.damageRanks.map(value => damageRankLabelMap.get(value) ?? value);
  return `（${labels.join('、')}）`;
});
const commonSearchParams = ref<CommonSearchParams | null>(null);
const getSearchParams = (): CommentIndexParams | null => {
  if (!commonSearchParams.value) return null;

  const { searchTypes: commentTypes, ...other } = commonSearchParams.value;
  return {
    comment_types: commentTypes as string[],
    share_scope: state.search.shareScope,
    only_current_user: state.search.onlyCurrentUser ? 1 : 0,
    ts_from: other.tsFrom,
    ts_to: other.tsTo,
    road_name_disps: other.roadNameDisps,
    directions: other.directions,
    kp_calc_from: other.kpCalcFrom,
    kp_calc_to: other.kpCalcTo,
    damage_ranks: state.search.damageRanks,
  };
};
const onChange = () => {
  emit('change');
};

onMounted(async() => {
  await resolveMastersPromise();
  setInitialSearchParams();
});

__expose({ getSearchParams });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GeoItemSearchCommon, {
      "search-params": commonSearchParams.value,
      "onUpdate:searchParams": _cache[0] || (_cache[0] = ($event: any) => ((commonSearchParams).value = $event)),
      "checkbox-key-prefix": checkboxKeyPrefix,
      "search-types": searchTypes.value,
      "search-type-map": searchTypeMap.value,
      "default-months-before": 6,
      "max-search-range-months": 6,
      onChange: onChange
    }, null, 8, ["search-params", "search-types", "search-type-map"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "title-area",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (state.showDamageRank = !state.showDamageRank))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas mr4", {'fa-caret-right': !state.showDamageRank, 'fa-caret-down': state.showDamageRank}])
        }, null, 2),
        _cache[10] || (_cache[10] = _createTextVNode(" 判定", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(selectedDamageRankDisp.value), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(COMMENT_DAMAGE_RANK_SEARCH_OPTIONS), (option) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "custom-control custom-checkbox ml15",
          key: option.value
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            class: "custom-control-input",
            id: `${checkboxKeyPrefix}-damage-rank-${option.value}`,
            value: option.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.search.damageRanks) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (onChange()))
          }, null, 40, _hoisted_4), [
            [_vModelCheckbox, state.search.damageRanks]
          ]),
          _createElementVNode("label", {
            class: "custom-control-label",
            for: `${checkboxKeyPrefix}-damage-rank-${option.value}`
          }, _toDisplayString(option.label), 9, _hoisted_5)
        ])), [
          [_vShow, state.showDamageRank]
        ])
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("span", {
        class: "title-area",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (state.showShareScope = !state.showShareScope))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas mr4", {
        'fa-caret-right': !state.showShareScope,
        'fa-caret-down': state.showShareScope,
      }])
        }, null, 2),
        _cache[11] || (_cache[11] = _createTextVNode(" 公開範囲", -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(selectedShareScopeDisp.value), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("select", {
          class: "custom-select",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.search.shareScope) = $event)),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (onChange()))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(masters).lov.shareScopes, (e) => {
            return (_openBlock(), _createElementBlock("option", {
              key: e.key,
              value: e.key
            }, _toDisplayString(e.valAlt), 9, _hoisted_9))
          }), 128))
        ], 544), [
          [_vModelSelect, state.search.shareScope]
        ])
      ], 512), [
        [_vShow, state.showShareScope]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("span", {
        class: "title-area",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (state.showOnlyCurrentUser = !state.showOnlyCurrentUser))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fas mr4", {
        'fa-caret-right': !state.showOnlyCurrentUser,
        'fa-caret-down': state.showOnlyCurrentUser,
      }])
        }, null, 2),
        _cache[12] || (_cache[12] = _createTextVNode(" 作成者", -1)),
        _createElementVNode("span", _hoisted_11, _toDisplayString(onlyCurrentUserDisp.value), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "custom-control-input",
          id: "only-current-user",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((state.search.onlyCurrentUser) = $event)),
          onChange: _cache[9] || (_cache[9] = ($event: any) => (onChange()))
        }, null, 544), [
          [_vModelCheckbox, state.search.onlyCurrentUser]
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("label", {
          class: "custom-control-label",
          for: "only-current-user"
        }, " 自分のみ ", -1))
      ], 512), [
        [_vShow, state.showOnlyCurrentUser]
      ])
    ])
  ]))
}
}

})